






















import ScenicItem from '../common/scenic_item.vue'
import { Component, Mixins, Watch, Provide, Inject } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { List, Toast, Sticky } from 'vant'
import SearchLoadList from '../mixins/LoadList'
import { SearchRefresh } from '../searchAll/index.vue'
import { getSearchResult, RequestType } from '../../search-service'
import { City } from '@/app/core/constant'
import { includes } from 'lodash'
const searchResModule = namespace('searchRes') //vuex

@Component({
  components: {
    [List.name]: List,
    [Sticky.name]: Sticky,
    ScenicItem
  }
})
export default class SearchThirdPartScenic extends Mixins(SearchLoadList) {
  @searchResModule.Mutation setThirdPartScenicNum!: (arg: number) => void
  @searchResModule.Mutation selectThirdPartScenicScreen!: (arg: string) => void
  @searchResModule.State location!: any
  @searchResModule.State selectCity!: City
  @searchResModule.State thirdPartScenicScreen!: string[]

  @searchResModule.Mutation resetThirdPartScenic!: () => void //重置筛选项

  @Inject('pageTrackParams')
  pageTrackParams!: any
  @Provide()
  clickid_200031 = '200031'

  mounted() {
    const { searchKey = '', tabs = '' } = this.$route.query
    this.keyWord = searchKey as string
    this.tabs = tabs as string
    this.onLoad()
    setTimeout(() => {
      this.$bus.$on(SearchRefresh.RefreshThirdPartScenic, () => {
        this.refresh()
      })
    }, 1000)
  }

  isSelect(name: string) {
    return includes(this.thirdPartScenicScreen, name)
  }

   changeScenicScreen(type: string , e: any) {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: '200032' , positionParam: {
      searchtype: e.target.innerText || ''
    } })
    this.selectThirdPartScenicScreen(type)
  }

  get cityName() {
    if (this.selectCity?.cityName) {
      return `只看${this.selectCity.cityName}`
    }
    return ''
  }

  @Watch('thirdPartScenicScreen')
  selectThirdPartScenicScreenChanged() {
    this.refresh()
  }

  destroyed() {
    this.$bus.$off(SearchRefresh.RefreshThirdPartScenic)
  }

  get emptyHeight() {
    const { top, height } = (this.$refs.classify as HTMLElement).getBoundingClientRect() || {}
    return document.body.clientHeight - top - height
  }

  get requestArgs() {
    const req: any = {}
    if (this.thirdPartScenicScreen.includes('currentCity')) {
      req.spotCityId = this.selectCity.cityId
    }
    const reserveToday = this.thirdPartScenicScreen.includes('reserveToday')
    const reserveTomorrow = this.thirdPartScenicScreen.includes('reserveTomorrow')
    if (reserveToday && reserveTomorrow) {
      req.ticketReserve = 2
    }else if(reserveToday && !reserveTomorrow){
      req.ticketReserve = 0
    }else if(!reserveToday && reserveTomorrow){
      req.ticketReserve = 1
    }
    return req
  }

  async onLoad() {
    const result = await getSearchResult({ tabs: this.tabs, keyWords: this.keyWord, type: RequestType.RequestThirdPartScenic, start: this.start, position: this.location,  defaultSort: true, ...this.requestArgs })
    const { code, data, msg } = result
    if (+code === 1) {
      if (data.spotInfo) {
        const { total, list: newData = [] } = data.spotInfo
        this.setThirdPartScenicNum(total)
        if (newData.length < 10) {
          this.finished = true
        }
        this.start = this.start + newData.length
        this.list.push(...newData)
      }
    } else {
      this.errormsg = msg || '加载出错，请稍后再试'
      if (this.list.length > 0) {
        this.error = true
        Toast(this.errormsg)
      }
    }
    this.loading = false
  }

  refresh() {
    this.reset()
    this.$nextTick(() => {
      if (this.isFixed) {
        window.scrollTo(0, this.scrollTop)
      }
    })
    this.onLoad()
  }

  resetCondition() {
    this.resetThirdPartScenic()
    this.refresh()
  }
}
